import type { MapIcon } from 'features/mapping/mapping.types';

const cameraStationaryBaseSize = 20;

const cameraPtzBaseSize = 36;

const cameraArrowSize = 44;

export const CameraStationaryBase: MapIcon = {
  name: 'CameraStationaryBase',
  width: cameraStationaryBaseSize,
  height: cameraStationaryBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMxZjFmMWYiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iIzYzOTNmMiIgaGVpZ2h0PSIxOCIgcng9IjEiIHdpZHRoPSIxOCIgeD0iMSIgeT0iMS4wMDA3MyIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iMTAuMDAyOSIgZmlsbD0iI2ZmZiIgcj0iMyIvPjwvZz48L3N2Zz4=',
};

export const CameraStationaryBaseOffline: MapIcon = {
  name: 'CameraStationaryBaseOffline',
  width: cameraStationaryBaseSize,
  height: cameraStationaryBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMxZjFmMWYiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iIzk5OSIgaGVpZ2h0PSIxOCIgcng9IjEiIHdpZHRoPSIxOCIgeD0iMSIgeT0iMSIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iMTAuMDAyMiIgZmlsbD0iI2ZmZiIgcj0iMyIvPjwvZz48L3N2Zz4=',
};

export const CameraStationaryBaseSelected: MapIcon = {
  name: 'CameraStationaryBaseSelected',
  width: cameraStationaryBaseSize,
  height: cameraStationaryBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMxZjFmMWYiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iIzUyZThlYiIgaGVpZ2h0PSIxOCIgcng9IjEiIHdpZHRoPSIxOCIgeD0iMSIgeT0iMS4wMDA3MyIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iMTAuMDAyOSIgZmlsbD0iI2ZmZiIgcj0iMyIvPjwvZz48L3N2Zz4=',
};

export const CameraStationaryWithArrow: MapIcon = {
  name: 'CameraStationaryWithArrow',
  width: cameraStationaryBaseSize,
  height: cameraStationaryBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCAyNCA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNCIgeT0iMjQiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjEiIGZpbGw9IiM2MzkzRjIiIHN0cm9rZT0iIzFGMUYxRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgY3g9IjEzIiBjeT0iMzMuMDAyMiIgcj0iMyIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzFGMUYxRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xMi40NDc0IDE1LjU5OTlMMTIuMDAwMiAxNS4zNzYzTDExLjU1MjkgMTUuNTk5OUw1LjI0NjU2IDE4Ljc1MzNMMTEuOTk5OCA1LjI0Njg5TDE4Ljc1MjcgMTguNzUyOEwxMi40NDc0IDE1LjU5OTlaIiBmaWxsPSIjNjM5M0YyIiBzdHJva2U9IiMxRjFGMUYiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K',
};

export const CameraPTZBase: MapIcon = {
  name: 'CameraPTZBase',
  width: cameraPtzBaseSize,
  height: cameraPtzBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMxZjFmMWYiIHN0cm9rZS13aWR0aD0iMiI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMC4wMDM3IiBmaWxsPSIjNjM5M2YyIiByPSI5Ii8+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMC4wMDI5IiBmaWxsPSIjZmZmIiByPSIzIi8+PC9nPjwvc3ZnPg==',
};

export const CameraPTZBaseOffline: MapIcon = {
  name: 'CameraPTZBaseOffline',
  width: cameraPtzBaseSize,
  height: cameraPtzBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMxZjFmMWYiIHN0cm9rZS13aWR0aD0iMiI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMC4wMDI5IiBmaWxsPSIjOTk5IiByPSI5Ii8+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMC4wMDIyIiBmaWxsPSIjZmZmIiByPSIzIi8+PC9nPjwvc3ZnPg==',
};

export const CameraPTZBaseSelected: MapIcon = {
  name: 'CameraPTZBaseSelected',
  width: cameraPtzBaseSize,
  height: cameraPtzBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiMxZjFmMWYiIHN0cm9rZS13aWR0aD0iMiI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMC4wMDM3IiBmaWxsPSIjNTJlOGViIiByPSI5Ii8+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMC4wMDI5IiBmaWxsPSIjZmZmIiByPSIzIi8+PC9nPjwvc3ZnPg==',
};

export const CameraPTZWithArrow: MapIcon = {
  name: 'CameraPTZWithArrow',
  width: cameraPtzBaseSize,
  height: cameraPtzBaseSize,
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCAyNCA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIzMy4wMDI5IiByPSI5IiBmaWxsPSIjNjM5M0YyIiBzdHJva2U9IiMxRjFGMUYiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIxMyIgY3k9IjMzLjAwMjIiIHI9IjMiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMxRjFGMUYiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTIuNDQ3NCAxNS41OTk5TDEyLjAwMDIgMTUuMzc2M0wxMS41NTI5IDE1LjU5OTlMNS4yNDY1NiAxOC43NTMzTDExLjk5OTggNS4yNDY4OUwxOC43NTI3IDE4Ljc1MjhMMTIuNDQ3NCAxNS41OTk5WiIgZmlsbD0iIzYzOTNGMiIgc3Ryb2tlPSIjMUYxRjFGIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==',
};

export const CameraArrow: MapIcon = {
  name: 'CameraArrow',
  width: cameraArrowSize,
  height: cameraArrowSize,
  data: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTUuMyAxOC44YzIuMjctNC41IDQuNTMtOSA2LjgtMTMuNWw2LjggMTMuNWMtMi4yNy0xLjEzLTQuNTMtMi4yNi02LjgtMy40LTIuMjcgMS4xMy00LjUzIDIuMjYtNi44IDMuNHoiIGZpbGw9IiM2MzkzZjIiIHN0cm9rZT0iIzFmMWYxZiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+',
};

export const CameraArrowOffline: MapIcon = {
  name: 'CameraArrowOffline',
  width: cameraArrowSize,
  height: cameraArrowSize,
  data: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTUuMyAxOC44YzIuMjctNC41IDQuNTMtOSA2LjgtMTMuNWw2LjggMTMuNWMtMi4yNy0xLjEzLTQuNTMtMi4yNi02LjgtMy40LTIuMjcgMS4xMy00LjUzIDIuMjYtNi44IDMuNHoiIGZpbGw9IiM5OTkiIHN0cm9rZT0iIzFmMWYxZiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+',
};

export const CameraArrowSelected: MapIcon = {
  name: 'CameraArrowSelected',
  width: cameraArrowSize,
  height: cameraArrowSize,
  data: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTUuMyAxOC44YzIuMjctNC41IDQuNTMtOSA2LjgtMTMuNWw2LjggMTMuNWMtMi4yNy0xLjEzLTQuNTMtMi4yNi02LjgtMy40LTIuMjcgMS4xMy00LjUzIDIuMjYtNi44IDMuNHoiIGZpbGw9IiM1MkU4RUIiIHN0cm9rZT0iIzFmMWYxZiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+Cg==',
};

/**
 * Icons to register as map images. Legend-only icons are left out so they
 * don't become map sprites.
 */
export const cameraIcons: MapIcon[] = [
  CameraStationaryBase,
  CameraStationaryBaseOffline,
  CameraStationaryBaseSelected,
  CameraPTZBase,
  CameraPTZBaseOffline,
  CameraPTZBaseSelected,
  CameraArrow,
  CameraArrowOffline,
  CameraArrowSelected,
];
